import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ArtistPostProfileWorkHistoryParams } from '@/features/artist/portfolio/api/profile-work-history/post/request';
import { artistPostProfileWorkHistory } from '@/features/artist/portfolio/api/profile-work-history/post/request';

export const useArtistProfileWorkHistoryMutation = (
  settings?: MutationSettings<
    ArtistPostProfileWorkHistoryParams,
    typeof artistPostProfileWorkHistory
  >
) =>
  useMutation({
    mutationKey: ['ArtistProfileWorkHistory'],
    mutationFn: ({ params, config }) =>
      artistPostProfileWorkHistory({
        params,
        config
      }),
    ...settings?.options
  });
